import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Application from './Components/admin/StateContext/AdminContext'
import UserState from './Components/Users/UserContext/UserState'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Application>
    <UserState>

      <React.StrictMode>
        <App />
      </React.StrictMode>

    </UserState>
  </Application>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
